import { Reducer, Action } from 'redux'
import { ILoadBoardPost } from 'types/loadBoardPosts'
import { SIDEBAR_ACTION_TYPES } from 'apps/booking/utils/actions/sidebar'
import {
  LOAD_BOARD_POST_EDIT_ACTION_TYPES,
  LOAD_BOARD_POST_FETCH_ACTION_TYPES,
  LOAD_BOARD_POST_COUNT_FETCH_ACTION_TYPES,
  MARKETPLACE_SETTINGS_EDIT_ACTION_TYPES,
  LOAD_BOARD_POST_EDIT_MODAL,
  MARKETPLACE_SETTINGS_EDIT_MODAL,
} from '../actions/loadBoardPosts'

const {
  LOAD_BOARD_POST_EDIT_FAILURE,
  LOAD_BOARD_POST_EDIT_REQUEST,
  LOAD_BOARD_POST_EDIT_SUCCESS,
} = LOAD_BOARD_POST_EDIT_ACTION_TYPES

const {
  LOAD_BOARD_POST_FETCH_FAILURE,
  LOAD_BOARD_POST_FETCH_REQUEST,
  LOAD_BOARD_POST_FETCH_SUCCESS,
} = LOAD_BOARD_POST_FETCH_ACTION_TYPES

const {
  LOAD_BOARD_POST_EDIT_MODAL_CLOSE,
  LOAD_BOARD_POST_EDIT_MODAL_OPEN,
} = LOAD_BOARD_POST_EDIT_MODAL

const {
  LOAD_BOARD_POST_COUNT_FETCH_FAILURE,
  LOAD_BOARD_POST_COUNT_FETCH_REQUEST,
  LOAD_BOARD_POST_COUNT_FETCH_SUCCESS,
} = LOAD_BOARD_POST_COUNT_FETCH_ACTION_TYPES

const {
  MARKETPLACE_SETTINGS_EDIT_MODAL_CLOSE,
  MARKETPLACE_SETTINGS_EDIT_MODAL_OPEN,
} = MARKETPLACE_SETTINGS_EDIT_MODAL

const {
  MARKETPLACE_SETTINGS_EDIT_FAILURE,
  MARKETPLACE_SETTINGS_EDIT_REQUEST,
  MARKETPLACE_SETTINGS_EDIT_SUCCESS,
} = MARKETPLACE_SETTINGS_EDIT_ACTION_TYPES

const { SIDEBAR_REQUESTED } = SIDEBAR_ACTION_TYPES

export interface ILoadBoardPostsState {
  loading: boolean
  error?: string
  showModal: boolean
  showSettingsModal: boolean
  posts: ILoadBoardPost[]
  similarPosts: ILoadBoardPost[]
  editing: boolean
  editingError?: string
  savingSettings: boolean
  settingError?: string
  count?: number
  id?: string
}
interface LoadBoardPostSuccessAction extends Action<string> {
  payload: {
    loadBoardPosts: ILoadBoardPost[]
    similarPosts: ILoadBoardPost[]
    requestData: {
      id: string
    }
  }
}
interface LoadBoardPostCountSuccessAction extends Action<string> {
  payload: {
    count?: number
  }
}
interface LoadBoardPostEditSuccessAction extends Action<string> {
  payload: {
    loadBoardPosts: ILoadBoardPost[]
  }
}

interface LoadBoardPostFailureAction extends Action<string> {
  payload: {
    requestData: {
      id: string
    }
  }
  error: string
}

type LoadBordPostReducerAction = LoadBoardPostSuccessAction | LoadBoardPostFailureAction

const defaultState: ILoadBoardPostsState = {
  loading: false,
  showModal: false,
  showSettingsModal: false,
  editing: false,
  savingSettings: false,
  posts: [],
  similarPosts: [],
}

const loadBoardPostsReducer: Reducer<ILoadBoardPostsState, LoadBordPostReducerAction> = (
  state = defaultState,
  action
) => {
  if (!action) return state

  switch (action.type) {
    case LOAD_BOARD_POST_FETCH_REQUEST: {
      const { payload } = action || {}
      const { requestData } = payload || {}
      const { id: activeShipmentId } = requestData || {}
      return {
        ...state,
        id: activeShipmentId,
        loading: true,
        error: undefined,
      }
    }
    case LOAD_BOARD_POST_FETCH_SUCCESS: {
      const {
        payload: { loadBoardPosts, requestData, similarPosts },
      } = action as LoadBoardPostSuccessAction
      const { id: activeShipmentId } = requestData || {}
      if (activeShipmentId === state.id) {
        return {
          ...state,
          loading: false,
          error: undefined,
          showModal: false,
          posts: loadBoardPosts,
          similarPosts,
        }
      }
      return {
        ...state,
        loading: true,
      }
    }
    case LOAD_BOARD_POST_FETCH_FAILURE: {
      const { payload } = action || {}
      const { requestData } = payload || {}
      const { id: activeShipmentId } = requestData || {}
      const { error } = action as LoadBoardPostFailureAction
      if (activeShipmentId === state.id) {
        return {
          ...state,
          loading: false,
          error,
        }
      }
      return {
        ...state,
      }
    }

    case LOAD_BOARD_POST_EDIT_REQUEST:
      return {
        ...state,
        editing: true,
        editingError: undefined,
      }

    case LOAD_BOARD_POST_EDIT_SUCCESS: {
      const {
        payload: { loadBoardPosts },
      } = action as LoadBoardPostEditSuccessAction
      return {
        ...state,
        editing: false,
        editingError: undefined,
        showModal: false,
        posts: loadBoardPosts,
      }
    }

    case LOAD_BOARD_POST_EDIT_FAILURE: {
      const { error } = action as LoadBoardPostFailureAction
      return {
        ...state,
        editing: false,
        editingError: error,
      }
    }

    case LOAD_BOARD_POST_COUNT_FETCH_REQUEST: {
      return {
        ...state,
        error: undefined,
      }
    }

    case LOAD_BOARD_POST_COUNT_FETCH_SUCCESS: {
      const {
        payload: { count },
      } = action as LoadBoardPostCountSuccessAction
      return {
        ...state,
        count,
      }
    }

    case LOAD_BOARD_POST_COUNT_FETCH_FAILURE: {
      const { error } = action as LoadBoardPostFailureAction
      return {
        ...state,
        error,
      }
    }

    case LOAD_BOARD_POST_EDIT_MODAL_OPEN: {
      return {
        ...state,
        showModal: true,
      }
    }

    case LOAD_BOARD_POST_EDIT_MODAL_CLOSE: {
      return {
        ...state,
        showModal: false,
      }
    }

    case MARKETPLACE_SETTINGS_EDIT_MODAL_OPEN: {
      return {
        ...state,
        showSettingsModal: true,
      }
    }

    case MARKETPLACE_SETTINGS_EDIT_MODAL_CLOSE: {
      return {
        ...state,
        showSettingsModal: false,
        settingError: undefined,
      }
    }

    case MARKETPLACE_SETTINGS_EDIT_SUCCESS: {
      return {
        ...state,
        showSettingsModal: false,
        savingSettings: false,
      }
    }

    case MARKETPLACE_SETTINGS_EDIT_FAILURE: {
      const { error } = action as LoadBoardPostFailureAction
      return {
        ...state,
        savingSettings: false,
        settingError: error,
      }
    }

    case MARKETPLACE_SETTINGS_EDIT_REQUEST: {
      return {
        ...state,
        savingSettings: true,
      }
    }

    case SIDEBAR_REQUESTED: {
      return {
        ...state,
        posts: [],
        similarPosts: [],
        error: '',
      }
    }

    default:
      return state
  }
}

export default loadBoardPostsReducer
